// extracted by mini-css-extract-plugin
export default {"centered":"collegeItem_centered__1n+0g","CollegeItem":"collegeItem_CollegeItem__X9xFe","degreeInfo":"collegeItem_degreeInfo__+-njp","details":"collegeItem_details__hXXj-"};